var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":_vm.title,"value":_vm.value,"items":_vm.items,"dense":"","menu-props":"auto","hide-details":""},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }